import {JsonObject} from '../interface/json';
import {config as sconf} from '../conf/settings';
import {Subject, lastValueFrom} from 'rxjs';

function getResult(err) {
  let result;
  if (err.response) {
    switch (err.response.status) {
      case 401:
        result = {result: 401, desc: '接口错误', data: err};
        break;
      case 500:
        result = {result: 500, desc: '接口错误', data: err};
        break;
      default:
        result = {result: 1317, desc: '接口错误', data: err};
    }
  } else {
    result = {result: 1317, desc: '接口错误', data: err};
  }
  return result;
}

export function $http(path: string, info: JsonObject, config?: JsonObject) {
  const url = config?.url || `${sconf.apiUrl}/${path}`;
  const $s = new Subject();
  (window as any).$sk.sxhr.post(url, info, config).then(res => {
      $s.next(res.data.body);
      $s.complete();
    }, err => {
      let result: any = getResult(err);
      $s.error(result);
      $s.complete();
    }
  ).catch(error => {
    $s.error({result: 1317, desc: '接口错误', data: error});
    $s.complete();
  });
  return $s;
}

export function $httpGet(url: string, info: JsonObject, config?: JsonObject) {
  const $s = new Subject();
  const gurl = config?.url || `${sconf.apiUrl}/${url}`;
  (window as any).$sk.sxhr.get(gurl, info, config).then(res => {
      $s.next(res.data);
      $s.complete();
    }, err => {
      let result: any = getResult(err);
      $s.error(result);
      $s.complete();
    }
  ).catch(error => {
    $s.error({result: 1317, desc: '接口错误', data: error});
    $s.complete();
  });
  return $s;
}

export function $post(path: string, info: JsonObject, config?: JsonObject) {
  return lastValueFrom($http(path, info, config));
}

export function $get(url: string, info: JsonObject, config?: JsonObject): Promise<any> {
  return lastValueFrom($httpGet(url, info, config));
}

export function $static(url: string, config?: JsonObject) {
  const $s = new Subject();
  (window as any).$sk.sxhr.get(`${sconf.apiCacheUrl}${url}.json?time_stamp=${new Date().getTime()}`, config).then(res => {
      $s.next(res.data.body);
      $s.complete();
    }, err => {
      let result: any = getResult(err);
      $s.error(result);
      $s.complete();
    }
  ).catch(error => {
    $s.error({result: 1317, desc: '接口错误', data: error});
    $s.complete();
  });
  return lastValueFrom($s);
}

export function $upload(info: any, curl?: string): Promise<any> {
  let url = `${curl || sconf.sbaseUrl}?command=`;
  const $s = new Subject();
  let command = encodeURI(
    JSON.stringify({
      size: 0,
      dst: '01-0300',
      orn: '01-0300',
      sess: '',
      type: 0x0002,
      cmd: 'file.upload',
      seq: 0,
      ver: 1000,
      body: ''
    })
  );
  const config = {
    headers: {'Content-Type': 'multipart/form-data'},
    url: url + command
  };
  (window as any).$sk.sxhr.post(url + command, info, config).then(res => {
      $s.next(res.data.body);
      $s.complete();
    }, err => {
      let result: any = getResult(err);
      $s.next(result);
      $s.complete();
    }
  ).catch(error => {
    $s.next({result: 1317, desc: '接口错误', data: error});
    $s.complete();
  });
  return lastValueFrom($s);
}

export function $skxhr(path: string, info: JsonObject, config?: JsonObject) {
  const $s = new Subject();
  const staticJson = (window as any).$sk.staticJson || {};
  const sp = staticJson[path] ? staticJson[path](info) : false;
  if (sp) {
    $static(sp).then(res => {
      $s.next(res);
      $s.complete();
    }, () => {
      $post(path, info, config).then(res => {
        $s.next(res);
        $s.complete();
      }, err => {
        $s.error(err);
        $s.complete();
      });
    });
  } else {
    $post(path, info, config).then(res => {
      $s.next(res);
      $s.complete();
    }, err => {
      $s.error(err);
      $s.complete();
    });
  }
  return $s;
}

export function $skxhrp(path: string, info: JsonObject, config?: JsonObject) {
  return lastValueFrom($skxhr(path, info, config));
}
